import { Navigate, useParams } from 'react-router-dom'

/**
 * Redirect legacy /reports/:reportId/schedule links to the report view
 * with the schedule dialog opened (see ReportViewPage's ?schedule param).
 */
export default function ReportScheduleRedirect() {
  const { reportId } = useParams()
  return <Navigate to={`/reports/${reportId}/view?schedule=true`} replace />
}
